import { Badge } from "../../../../components/Badge/Badge";
import { formatNumber } from "../../../../utils/NumbersFormatting";
import type { BadgesProps } from ".";

const BadgesRegular: React.FC<BadgesProps> = ({ data }) => {
  const { planName, regularBillingInfo } = data;

  const maxTokensCount = regularBillingInfo
    ? Math.max(
        regularBillingInfo.maxQuantityPerBillingPeriod,
        regularBillingInfo.billingPeriodLimit,
      )
    : 0;

  return (
    <div className="d-grid grid-stats-section">
      <div className="row gy-5 g-xl-5 row-plex widget-container">
        <div className="col-md-6 col-lg-6 col-xl-6 col-xxl-6 mb-xl-0">
          <Badge
            variant="info"
            content={{
              value: planName,
              title: "Your current plan",
            }}
          />
        </div>

        {/* 
          todo: no data
          <div className="col-md-4 col-lg-4 col-xl-4 col-xxl-4 mb-xl-0">
          <Badge
            variant="primary"
            content={{
              value: `${formatCurrency(450)}`,
              title: 'Cost overages',
              tooltipText: 'The total cost due for amount of cache items over the plan limit.',
              rightItems: [
                {
                  text: `${formatCurrency(43)}`,
                  subtitle: 'cost savings',
                },
              ],
            }}
          />
        </div> */}

        <div className="col-md-6 col-lg-6 col-xl-6 col-xxl-6 mb-xl-0">
          <Badge
            variant={
              (regularBillingInfo?.current || 0) >= maxTokensCount
                ? "danger"
                : "success"
            }
            content={{
              value: `${formatNumber(
                regularBillingInfo?.current || 0,
              )} / ${formatNumber(maxTokensCount)}`,
              title: "Cache items",
              tooltipText:
                "The total amount of cache items vs. cache items included in the plan",
            }}
          />
        </div>
      </div>
    </div>
  );
};

export { BadgesRegular };
